import { Grid, Filter, Page, Sort, RecordClickEventArgs, parentsUntil, Toolbar, Edit } from '@syncfusion/ej2-grids';
import { Query, DataManager, WebApiAdaptor } from '@syncfusion/ej2-data';
import { MultiSelect, ChangeEventArgs } from '@syncfusion/ej2-dropdowns';
import { Toastr } from '../Helpers/Toastr';
import { UserDataService } from '../DataService/UserDataService';
import { DynamicVariables } from '../Common/DynamicVariables';
import { ModalHelper } from '../Helpers/ModalHelper';
import { ConfirmModal } from '../Helpers/ConfirmModal';

export class UsersManager {

    constructor(private containerElement: JQuery) { }

    private workbookGrid : Grid;

    private addOrUpdateUserModalHelper : ModalHelper;
    // private addManualProjectManager : AddManualProjectManager;

    private officesEnabled : boolean;

    public initialize() {
        var self = this;

        Grid.Inject(Filter, Page, Sort, Toolbar, Edit);

        self.initializeDataWarehouseDocumentsTable();
    }

    private initializeDataWarehouseDocumentsTable() {
        var self = this;

        var loadingContainer = self.containerElement.find('#loading-container');
        var usersContainer = self.containerElement.find('#users-container');

        self.officesEnabled = self.containerElement.data('offices-enabled');

        var gridElement : JQuery<HTMLElement> = self.containerElement.find('#Grid');
        var gridContentElement : JQuery<HTMLElement> = gridElement;


        self.addOrUpdateUserModalHelper = new ModalHelper();
        self.addOrUpdateUserModalHelper.createModal("add-or-update-user-popup", true);

        let data: DataManager = new DataManager({
            url: '/api/company/user/list',
            adaptor: new WebApiAdaptor,
        });

        var dataColumns : any = [
            { field: 'Id', isPrimaryKey: true, visible: false, allowEditing: false, validationRules: { required: true }},
            { field: 'UserInitials', headerText: 'Initials',  width: 80, allowEditing: false},
            { field: 'UserFullName', headerText: 'Name',  width: 300, allowEditing: false},
            { field: 'UserEmail', headerText: 'Email', width: 450, allowEditing: false},
            { field: 'UserCompanyRoles', headerText: 'Role(s)', template: '#userRolesTemplate', allowEditing: true, validationRules: { required: true }},
            { field: 'ExtraActions', headerText: '', allowFiltering: false, autoFit: true, textAlign: 'Right', template: '${getUsersActions(data.Id)}', width: 100 }
        ]

        if(self.officesEnabled) {
            dataColumns = [
                { field: 'Id', isPrimaryKey: true, visible: false, allowEditing: false, validationRules: { required: true }},
                { field: 'UserInitials', headerText: 'Initials',  width: 80, allowEditing: false},
                { field: 'UserFullName', headerText: 'Name',  width: 300, allowEditing: false},
                { field: 'UserEmail', headerText: 'Email', width: 450, allowEditing: false},
                { field: 'Office', headerText: 'Office', width: 200, allowEditing: false},
                { field: 'UserCompanyRoles', headerText: 'Role(s)', template: '#userRolesTemplate', allowEditing: true, validationRules: { required: true }},
                { field: 'ExtraActions', headerText: '', allowFiltering: false, autoFit: true, textAlign: 'Right', template: '${getUsersActions(data.Id)}', width: 100 }
            ]
        }

        self.workbookGrid = new Grid(
        {
            height: '100%',
            toolbarTemplate: '#toolbar-template',
            dataSource: data,
            editSettings: { allowEditing: false, allowAdding: false, allowDeleting: false, mode: 'Normal', newRowPosition: 'Top' },
            columns: dataColumns,
            allowSorting: false,
            allowPaging: true,
            allowFiltering: false,
            allowSelection: false,
            allowResizing: false,
            recordDoubleClick: (e) => {
                e.cancel = true;
                return;
            },
            queryCellInfo: dropdown,
            actionComplete: actionComplete,
            pageSettings: { pageSize: 50 },
            created: () => {
                gridContentElement = gridContentElement.find('.e-content')

                loadingContainer.addClass('d-none');
                usersContainer.removeClass('d-none');
            },
            dataBound: () => {
                self.containerElement.find('button[data-action="edit-user"]').each((index, element) => {
                    var editButton = $(element);
                    editButton.off('click').on('click', () => {
                        var userLinkId = editButton.data('user-link-id');
                        editButton.prop('disabled', true);

                        self.addOrUpdateUserModalHelper.load(`?userLinkId=${userLinkId}&handler=AddOrUpdateUser`, undefined, () => {
                            editButton.prop('disabled', false);
                        }, 
                        undefined);
                        
                    })
                })

                self.containerElement.find('button[data-action="remove-user"]').each((index, element) => {
                    var deleteButton = $(element);
                    deleteButton.off('click').on('click', () => {
                        var userLinkId = deleteButton.data('user-link-id');
                        new ConfirmModal().initialize('Remove user', 'Are you sure you want to remove this user?</br>This action cannot be reverted.', () => {
                            UserDataService.removeUserLink(userLinkId, (result) => {
                                if(result == true) {
                                    var index = self.workbookGrid.getRowIndexByPrimaryKey(userLinkId);
                                    var row = self.workbookGrid.getRowByIndex(index);
                                    $(row).remove();
                                }
                            })
                        }, () => {
                        }, 'Confirm', 'Cancel')
                        
                    })
                })
            }
        });
        self.workbookGrid.appendTo('#Grid');

        //TODO: Roles based on plugins

        var dropData: string[] = DynamicVariables.WorkloadmanagerEnabled ? ['Manager', 'Admin', 'WorkloadManager', 'WorkloadPurchaser'] : ['Manager', 'Admin'];
        function dropdown(args) {
            if (args.column.field === 'UserCompanyRoles') {
                var drop = new MultiSelect({
                    dataSource: dropData,
                    value: args.data['UserCompanyRoles'],
                    popupHeight: 350,
                    popupWidth: 200,
                    openOnClick: true,
                    closePopupOnSelect: false,
                    changeOnBlur: true,
                    change: (changeArgs) => {
                        var recordId = args.data['Id'];
                        var newValue = changeArgs.value;

                        UserDataService.updateUserLinkRoles(recordId, newValue, () => {

                        });
                        
                        // if (args.e.target != undefined && args.e.rowData != undefined) {
                        //     var parsedTarget = $(args.e.target); 
                        //     var documentId = args.e.rowData["Id"];
                        //     console.log(documentId);
        
                        //     // if(parsedTarget.data('action') == 'sent-to-erp' || parsedTarget.parent().data('action') == 'sent-to-erp' && documentId != undefined) {
                        //     //     parsedTarget.prop('disabled', true);
        
                        //     //     DataWarehouseDataService.sentDocHeaderToErp(documentId, revisionId, (result) => {
                        //     //         Toastr.Success('Success', 'The document has successfully been sent to the ERP');
                        //     //         self.workbookGrid.refresh();
                        //     //     })
                        //     // }
                        //     // else {
                        //     //     location.href = `/Company/DataWarehouse/${documentId}/Details`;
                        //     // }
                        // }
                        //console.log(e);
                    }
                });
                
                drop.appendTo(args.cell.querySelector('#userRolesDropdown'));
            }
        }

        //add-user-button

        function actionComplete(args) {
            console.log(args);
            if ((args.requestType == 'save')) {
                args.promise.then((result) => {
                    if(result.isSuccessStatusCode == false) {
                        Toastr.Error("Error when saving the changes to the user.", args.reasonPhrase);
                    }
                })
            }
        }

        var toolbar = this.containerElement.find('#toolbar-template');
        if(toolbar != undefined && toolbar.length > 0) {
            var addButton = toolbar.find('#add-user-button');
            addButton.off('click').on('click', () => {
                self.addOrUpdateUserModalHelper.load(`?handler=AddOrUpdateUser`, undefined, () => {

                }, 
                undefined);
            })
        }

        (<any>window).initializeAddOrUpdateUser = () => {
            if(self.addOrUpdateUserModalHelper.getModalContainer().find('.alert-danger').length == 0) {
                self.workbookGrid.refresh();
            }
            // else {
            //     self.addManualProjectManager.initialize();
            // }
        }
    }
}